import { useCallback, useState } from "react";
import authService from "../services/authentication.service";
import useAlert from "./useAlert";

const useForgotPassword = () => {
  const [loading, setLoading] = useState(false);

  const [emailSubmitted, setEmailSubmitted] = useState(false);

  const {
    showErrorAlert,
    alertProps,
    alertMessage,
    getAlertMessageAndSupportContent,
  } = useAlert();

  const forgotPassword = useCallback(
    async (email: string, mobile?: "0" | "1" | null) => {
      try {
        setLoading(true);

        const { success } = await authService.forgotPassword(email);
        if (!success) {
          //Handle Failure
          const { message } = getAlertMessageAndSupportContent(
            "FORGOT_PASSWORD.EMAIL_CONTACT",
            "Please Contact your Organization Admin or<br></br>Customer Service to reset your Password",
            {
              br: () => <br></br>,
            }
          );
          showErrorAlert(message);
          return;
        }
        //Handle Success
        setEmailSubmitted(true);
      } finally {
        setLoading(false);
      }
    },
    [getAlertMessageAndSupportContent, showErrorAlert]
  );

  return {
    forgotPassword,
    loading,
    alertProps,
    alertMessage,
    emailSubmitted,
  };
};
export default useForgotPassword;
